// extracted by mini-css-extract-plugin
module.exports = {"TickerPills":"TickerPills_TickerPills__EUd_L","pill":"TickerPills_pill__Mqbtl"};